import _objectWithoutProperties from "/usr/share/nginx/html/gatsby_airtkt_page_desk/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["children"];

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import "core-js/modules/es.array.flat.js";
import "core-js/modules/es.array.unscopables.flat.js";
import React, { createContext, memo, useContext } from 'react';
var HighlightContext = createContext(null);

var Provider = function Provider(_ref) {
  var children = _ref.children,
      props = _objectWithoutProperties(_ref, _excluded);

  return React.createElement(HighlightContext.Provider, {
    value: props
  }, children);
};

function findOccurrences(content, contentLower, keyword) {
  keyword = keyword.toLocaleLowerCase();
  var occ = [];

  for (var i = 0; (i = contentLower.indexOf(keyword, i)) > -1; i += keyword.length) {
    occ.push({
      start: i,
      end: i + keyword.length,
      raw: content.substr(i, keyword.length)
    });
  }

  return occ;
}

function replaceOccurrences(content, keywords, wrapHighlight) {
  var res = [];
  var contentLower = content.toLocaleLowerCase();
  var occurrences = keywords.map(function (keyword) {
    return findOccurrences(content, contentLower, keyword.toLocaleLowerCase());
  }).flat().sort(function (a, b) {
    return a.start - b.start;
  });
  var i = 0;
  var id = 0;

  var _iterator = _createForOfIteratorHelper(occurrences),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var occ = _step.value;
      if (occ.start !== 0) res.push(React.createElement("span", {
        key: id++
      }, content.substring(i, occ.start)));
      res.push(wrapHighlight(occ.raw, id++));
      i = occ.end;
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  if (i != content.length) res.push(React.createElement("span", {
    key: id++
  }, content.substr(i)));
  return res;
}

var Highlight = memo(function (_ref2) {
  var content = _ref2.content,
      keywords = _ref2.keywords,
      highlightClassName = _ref2.highlightClassName;

  var _a, _b;

  var ctx = useContext(HighlightContext);
  keywords = (keywords !== null && keywords !== void 0 ? keywords : []).concat((_a = ctx === null || ctx === void 0 ? void 0 : ctx.keywords) !== null && _a !== void 0 ? _a : []).filter(function (k) {
    return !!k;
  });
  highlightClassName = (_b = ctx === null || ctx === void 0 ? void 0 : ctx.highlightClassName) !== null && _b !== void 0 ? _b : highlightClassName;
  return React.createElement(React.Fragment, null, replaceOccurrences(content, keywords !== null && keywords !== void 0 ? keywords : [], function (c, id) {
    return React.createElement("span", {
      key: id,
      className: highlightClassName !== null && highlightClassName !== void 0 ? highlightClassName : 'highlight-highlighted'
    }, c);
  }));
});

function useHighlightContext() {
  return useContext(HighlightContext);
}

export { Highlight, HighlightContext, Provider, useHighlightContext };